// 存入
export function setStorage(key,val){
    return localStorage.setItem(key,val)
}

// 取出
export function getStorage(key){
    return localStorage.getItem(key)
}

// 移除
export function  removeStorage(key){
   return localStorage.removeItem(key)
}
